import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTenantGroup } from 'Services';
import { RQ_DELETE_TENANT_GROUP, RQ_TENANT_GROUPS } from 'Utils';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';

type DeleteTenantGroupProps = {
    mutationOptions?: {
        onSuccess: any;
        onError: any;
    };
};

function useDeleteTenantGroup({ mutationOptions }: DeleteTenantGroupProps) {
    const { t } = useTranslation();
    const { addAlert } = useAlertBanner();
    const queryClient = useQueryClient();

    const handleOnSuccess = (variable: TenantGroup) => {
        addAlert({
            id: 'delete-tenant-group-success',
            content: t('Delete Tenant Group success message', { name: variable.name }),
            status: 'success'
        });
        queryClient.invalidateQueries([RQ_TENANT_GROUPS]);
    };

    const handleOnError = (variable: TenantGroup) => {
        addAlert({
            id: 'delete-tenant-group-error',
            content: t('Delete Tenant Group error message', { name: variable.name }),
            status: 'danger'
        });
    };

    return useMutation([RQ_DELETE_TENANT_GROUP], deleteTenantGroup, {
        onSuccess: (_data, variable) => {
            handleOnSuccess(variable);
            mutationOptions?.onSuccess();
        },
        onError: (_data, variable) => {
            handleOnError(variable);
            mutationOptions?.onError();
        }
    });
}

export default useDeleteTenantGroup;
